// ============================================================
// PREZENCE — My Attendance Page (Employee)
// ============================================================
import React, { useState, useEffect, useCallback } from 'react';
import api from '../../api/client';
import toast from 'react-hot-toast';

export default function MyAttendance() {
  const [logs, setLogs]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [month, setMonth]   = useState(new Date().getMonth() + 1);
  const [year, setYear]     = useState(new Date().getFullYear());

  const fetchLogs = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get(`/attendance/my-history?month=${month}&year=${year}`);
      setLogs(res.data.data || []);
    } catch { toast.error('Failed to load attendance'); }
    finally { setLoading(false); }
  }, [month, year]);

  useEffect(() => { fetchLogs(); }, [fetchLogs]);

  const statusBadge = s => ({
    present:  'badge-green',  late:     'badge-amber',
    absent:   'badge-red',    half_day: 'badge-blue',
    on_leave: 'badge-purple', holiday:  'badge-gray',
  })[s] || 'badge-gray';

  const totalPresent  = logs.filter(l => l.status === 'present' || l.status === 'late').length;
  const totalLate     = logs.filter(l => l.status === 'late').length;
  const totalAbsent   = logs.filter(l => l.status === 'absent').length;
  const avgHours      = logs.length ? (logs.reduce((a,b) => a + (b.total_hours||0), 0) / logs.filter(l=>l.total_hours).length).toFixed(1) : 0;

  return (
    <div style={{ animation:'fadeIn 0.4s ease', maxWidth:900, margin:'0 auto' }}>
      <div className="page-header" style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
        <div>
          <h1 className="page-title">My Attendance</h1>
          <p className="page-sub">Track your attendance history and working hours</p>
        </div>
        <div style={{ display:'flex', gap:10 }}>
          <select className="form-select" style={{ width:'auto', padding:'8px 12px' }} value={month} onChange={e=>setMonth(+e.target.value)}>
            {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'].map((m,i)=>(
              <option key={i} value={i+1}>{m}</option>
            ))}
          </select>
          <select className="form-select" style={{ width:'auto', padding:'8px 12px' }} value={year} onChange={e=>setYear(+e.target.value)}>
            {[2024,2025,2026].map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
      </div>

      <div className="grid-4" style={{ marginBottom:24 }}>
        {[
          { label:'Present Days', value:totalPresent, color:'#22c55e' },
          { label:'Late Arrivals', value:totalLate,  color:'#f59e0b' },
          { label:'Absent Days',  value:totalAbsent, color:'#ef4444' },
          { label:'Avg Hours/Day',value:`${isNaN(avgHours)?0:avgHours}h`, color:'#3ba8ff' },
        ].map((s,i) => (
          <div key={i} className="card" style={{ padding:'18px 20px' }}>
            <p style={{ fontSize:10, color:'#475569', letterSpacing:'0.1em', fontFamily:"'JetBrains Mono'", marginBottom:8 }}>{s.label.toUpperCase()}</p>
            <p style={{ fontSize:28, fontWeight:800, color:s.color, fontFamily:"'JetBrains Mono'" }}>{s.value}</p>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-header"><span className="card-title">ATTENDANCE LOG</span></div>
        {loading ? <div style={{ display:'flex', justifyContent:'center', padding:40 }}><div className="spinner" style={{width:24,height:24}} /></div> :
        logs.length === 0 ? <div className="empty-state"><div className="empty-state-icon">📅</div><div className="empty-state-text">No attendance records for this month</div></div> :
        <div className="table-wrap">
          <table>
            <thead><tr><th>Date</th><th>Clock In</th><th>Clock Out</th><th>Total Hours</th><th>Status</th></tr></thead>
            <tbody>
              {logs.map(log => (
                <tr key={log.id}>
                  <td style={{ fontWeight:600, color:'#e2e8f0' }}>{new Date(log.date).toLocaleDateString('en-IN',{weekday:'short',day:'numeric',month:'short'})}</td>
                  <td style={{ fontFamily:"'JetBrains Mono'", fontSize:12, color:'#22c55e' }}>{log.clock_in ? new Date(log.clock_in).toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'}) : '—'}</td>
                  <td style={{ fontFamily:"'JetBrains Mono'", fontSize:12, color:'#ef4444' }}>{log.clock_out ? new Date(log.clock_out).toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'}) : '—'}</td>
                  <td style={{ fontFamily:"'JetBrains Mono'", fontSize:13, fontWeight:700, color:'#63dcbc' }}>{log.total_hours ? `${log.total_hours}h` : '—'}</td>
                  <td><span className={`badge ${statusBadge(log.status)}`}>{log.status.replace('_',' ').replace(/\b\w/g,c=>c.toUpperCase())}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        }
      </div>
    </div>
  );
}
